import { useMutation } from "@tanstack/react-query";
import httpService from "../common/http.service";
import { toast } from "react-toastify";

// The core API call
const uploadAdminImageApi = async (file) => {
  const formData = new FormData();
  formData.append("image", file); 

  const response = await httpService.post("/upload/productimage", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  
  return response.data; 
};

// The React Query Hook
export const useUploadAdminImage = () => {
  return useMutation({
    mutationFn: uploadAdminImageApi,
    onSuccess: () => {
      toast.success("Image uploaded successfully!");
    },
    onError: (err) => {
      toast.error(err.response?.data?.message || "Failed to upload image.");
    },
  });
};